import { render } from "./EmailTemplateEditor.vue?vue&type=template&id=2128f14c&scoped=true&ts=true"
import script from "./EmailTemplateEditor.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateEditor.vue?vue&type=script&lang=ts"

import "./EmailTemplateEditor.vue?vue&type=style&index=0&id=2128f14c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2128f14c"]])

export default __exports__